/** @module Apparel/ProductSize/SizeRangesTable */
define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/store/Nodes",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductSize/SizeSet"
], function(declare, Memory, Nodes, Widget, xml, Query, SizeSet) {

	return declare(Widget, {
		/** @property {Object<string,string[]>} sizeSetsPerDimension - map of size sets per dimension types */
		sizeSetsPerDimension: null,

		/** @property {Memory} twoDimensionSizeStore - store of 2d sizes in the system */
		twoDimensionSizeStore: null,

		/**
		 * Return size set for 2d size range that includes all available sizes in the system
		 * @param {Node} sizeRange 
		 * @return {SizeSet}
		 */
		get2dSizeSet: function(sizeRange) {
			const {cacheView, sizeSetsPerDimension, twoDimensionSizeStore} = this;
			const {Dimension1Type, Dimension2Type} = sizeRange;
			const key = Dimension1Type + "^" + Dimension2Type;
			let sizeSet = sizeSetsPerDimension[key];

			if (!sizeSet) {
				// construct size set
				const results = twoDimensionSizeStore.query({Dimension1Type, Dimension2Type});
				const urls = results.map(item => item.id);
				sizeSet = new SizeSet(cacheView, urls);
				sizeSetsPerDimension[key] = sizeSet;
			}

			return sizeSet;
		},

		/**
		 * @override
		 * Query for all 2d sizes
		 */
		onViewStart: function(dfds) {
			const {cacheView} = this;
			const store = new Nodes({
				cachingStore: cacheView,
				filterQuery: new Query().Attr("IsTwoDim", xml.OP_EQUALS, true),
				typeNode: "ProductSize",
				requestParameters: {
					"Dep.Path": "Child:Dimension1Size;Dimension2Size"
				}
			});

			dfds.push(store.query().then(results => {
				const data = results.map(node => {
					const size1 = cacheView.get(node.Dimension1Size);
					const size2 = cacheView.get(node.Dimension2Size);
					
					return {
						id: node.$URL,
						Dimension1Type: size1 && size1.DimensionType,
						Dimension2Type: size2 && size2.DimensionType
					};
				});

				this.twoDimensionSizeStore = new Memory({data});
				this.sizeSetsPerDimension = {};
			}));

			this.inherited(arguments);
		}
	});
});
